<template>
  <details id="lexinKeyboard" :open="getDetailsOpenValue()">
      <summary @click="updateKeyboardIsOpen">{{ $t('message.keyboard-select-keyboard-for-special-characters') }}</summary>
      <LexinKeyboardSelectLanguage @update="updateSelectedLanguage" :selectedLanguage="selectedLanguage"></LexinKeyboardSelectLanguage>
      <LexinKeyboardContent :selectedLanguage="selectedLanguage" @add-to-search="addToSearchInput"></LexinKeyboardContent>
  </details>
</template>

<script>
    import LexinKeyboardSelectLanguage from "./LexinKeyboardSelectLanguage.vue";
    import LexinKeyboardContent from "./LexinKeyboardContent.vue";

    export default {
        data() {
            return {
                selectedLanguage: localStorage.getItem('lexinSelectedKeyboard') || 'nob',
                keyboardIsOpen: this.getDetailsOpenValue()
            }
        },

        components: {
            LexinKeyboardSelectLanguage,
            LexinKeyboardContent
        },

        methods: {
            addToSearchInput(searchValue) {
                this.$emit('add-to-search', searchValue);
            },

            updateSelectedLanguage(language) {
                this.selectedLanguage = language;
            },

            updateKeyboardIsOpen() {
                let detailsEl = document.getElementById('lexinKeyboard');
                if (detailsEl) {
                    if (!detailsEl.open) {
                        this.keyboardIsOpen = 'true';
                    } else {
                        this.keyboardIsOpen = 'false';
                    }

                    localStorage.setItem('lexinKeyboardIsOpen', this.keyboardIsOpen);
                }
            },

            getDetailsOpenValue() {
                let value = false;
                let keyboardIsOpen = localStorage.getItem('lexinKeyboardIsOpen');

                if (keyboardIsOpen === 'true') {
                    value = true;
                }

                return value;
            }
        },

        updated() {
            localStorage.setItem('lexinSelectedKeyboard', this.selectedLanguage);
        }
    };

</script>
